<template>
  <div class="">
    <button
      v-if="hasNewUpdated"
      class="new-notice btn btn-sm btn-primary rounded-pill"
      @click="reloadPage"
    >
      <i class="fas fa-arrow-up"></i>
      New Updates
    </button>

    <div class="form-row">
      <div class="col-md-2">
        <IdeaFilter :queryObject="queryObject" />
      </div>
      <div class="col-md-7">
        <CreateIdea
          @click="
            editing = true;
            ideaId = 0;
          "
        />

        <IdeaSort :total="total" :queryObject="queryObject" />

        <div class="text-center" v-if="loading">
          <CSpinner color="info" />
        </div>

        <template v-else>
          <CCard
            v-for="(item, i) in items"
            :key="`item-${i}`"
            class="mb-3"
            style="border-top: 3px solid #0080ff"
          >
            <CCardHeader class="py-2" style="line-height: 2rem">
              <router-link
                :to="{ name: 'IdeaDetail', params: { id: item.Id } }"
                class="text-dark"
              >
                <i class="fas fa-lightbulb"></i> &nbsp;
                <strong>{{ item.Title }}</strong>
              </router-link>

              <div class="d-inline-block float-right align-right">
                <div class="form-row">
                  <div class="col-auto">
                    <CBadge
                      :color="$const.IDEA_STATUS_TEXT[item.Status].color"
                      class="px-2 py-1 mr-2"
                    >
                      {{
                        $const.IDEA_STATUS_TEXT[item.Status].text.toUpperCase()
                      }}
                    </CBadge>
                  </div>
                  <div
                    class="col-auto"
                    v-if="
                      (item.Status == $const.IDEA_STATUS.New ||
                        item.Status == $const.IDEA_STATUS.NeedsInfo) &&
                      sipUser &&
                      sipUser.UserId == item.CreatedBy
                    "
                  >
                    <CDropdown
                      class="c-header-nav-items border-left"
                      placement="bottom-end"
                      add-menu-classes="py-0"
                    >
                      <template #toggler>
                        <CButton
                          color="none"
                          size="sm"
                          class="float-right d-inline"
                          title="Options"
                          style="font-size: 1.2rem; line-height: 1rem"
                        >
                          <i class="fas fa-ellipsis"></i>
                        </CButton>
                      </template>
                      <CDropdownItem
                        class="px-2 py-1"
                        @click="
                          {
                            ideaId = item.Id;
                            editing = true;
                          }
                        "
                      >
                        <i class="fas fa-pencil mr-2"></i> Edit post
                      </CDropdownItem>
                      <CDropdownItem
                        class="px-2 py-1 text-danger"
                        @click="deletePost(item)"
                      >
                        <i class="fas fa-trash mr-2"></i> Delete post
                      </CDropdownItem>
                    </CDropdown>
                  </div>
                </div>
              </div>
            </CCardHeader>

            <CCardBody class="px-3 py-2">
              <div class="form-row">
                <div class="col-lg-1 col-2">
                  <img
                    src="/img/avatar.png"
                    alt=""
                    v-if="item.IsAnonymous"
                    class="rounded-circle w-100"
                  />
                  <img
                    v-else
                    :src="`${$http.defaults.baseURL}/Document/download/Employees/${item.CreatedByNavigation.Email}.jpg`"
                    class="rounded-circle w-100"
                    @error="replaceByDefault"
                  />
                </div>
                <div class="col-lg-11 col-10">
                  <h6>
                    {{
                      item.IsAnonymous
                        ? "Anonymous"
                        : item.CreatedByNavigation.Name
                    }}
                  </h6>
                  <div class="small text-muted">
                    <i class="fas fa-clock"></i>
                    {{ showDateTime(item.UpdatedAt) }}
                    &nbsp;|&nbsp; <i class="fas fa-globe"></i>
                    {{ item.Area.Name }}
                  </div>
                </div>
              </div>
              <div class="description short py-2">
                <pre
                  :class="{ 'more-info': item.seeMore }"
                  v-html="
                    $func.getBoldString(item.Description, queryObject.keywords)
                  "
                ></pre>
                <span
                  v-if="!item.seeMore"
                  role="button"
                  class="see-more text-muted"
                  @click="item.seeMore = true"
                >
                  <strong>...see more</strong>
                </span>
              </div>

              <div class="row" v-if="item.AttachedFiles">
                <div class="image-post">
                  <router-link
                    :to="{ name: 'IdeaDetail', params: { id: item.Id } }"
                    class="w-100 d-block text-center"
                  >
                    <img
                      v-lazy="
                        `${$http.defaults.baseURL}/Document/download/SipIdea$${
                          item.Id
                        }/${getFirstImageName(item.AttachedFiles)}`
                      "
                      alt=""
                      @error="
                        (e) => {
                          e.target.remove();
                        }
                      "
                      class="img-fluid"
                    />
                  </router-link>
                </div>
              </div>

              <a
                href="javascript:"
                class="text-muted"
                @click="showingVoteId = item.Votes ? item.Id : 0"
              >
                <i class="far fa-thumbs-up"></i>
                {{ item.Votes ? item.Votes : 0 }} likes
              </a>
            </CCardBody>
            <CCardFooter>
              <div class="row">
                <div class="col-4">
                  <a href="javascript:" class="text-muted" v-if="item.working">
                    <i class="fas fa-thumbs-up"></i>
                    Like
                  </a>
                  <a
                    v-else-if="item.SipIdeaVotes && item.SipIdeaVotes.length"
                    href="javascript:"
                    class="text-primary"
                    @click="unvoteIdea(item)"
                  >
                    <i class="fas fa-thumbs-up"></i>
                    Like
                  </a>
                  <a
                    v-else
                    href="javascript:"
                    class="text-muted"
                    @click="voteIdea(item)"
                  >
                    <i class="fas fa-thumbs-up"></i>
                    Like
                  </a>
                </div>
                <div class="col-4"></div>
                <div class="col-4 text-right"></div>
              </div>
            </CCardFooter>
          </CCard>

          <Pagination
            :pagingInfo="{
              page: queryObject.page,
              pageSize: queryObject.pageSize,
              total,
            }"
            @page="navigatePage"
          />
        </template>
      </div>
      <div class="col-md-3">
        <TopIdea :queryObject="queryObject" />
      </div>
    </div>

    <editPopup
      :editing.sync="editing"
      :ideaId.sync="ideaId"
      @reload="reloadInfo"
    />

    <votesPopup :entityId.sync="showingVoteId" />
  </div>
</template>

<script>
import IdeaFilter from "./Filter.vue";
import TopIdea from "./Top.vue";
import CreateIdea from "./Create.vue";
import Pagination from "@/components/pagination.vue";
import editPopup from "./Popup.vue";
import votesPopup from "@/components/sipVotes.vue";
import IdeaSort from "@/components/Sort.vue";

export default {
  components: {
    IdeaFilter,
    TopIdea,
    CreateIdea,
    Pagination,
    editPopup,
    votesPopup,
    IdeaSort,
  },
  name: "Idea",
  data() {
    return {
      items: [],
      total: 0,
      timeoutQuery: null,
      loading: false,
      editing: false,
      ideaId: 0,
      showingVoteId: 0,
      hasNewUpdated: false,
    };
  },
  created: function () {
    this.$messageHub.$on("IdeaVoteChange", this.ideaVoteChange);
    this.$messageHub.$on("UpdatedNotice", this.updateNotice);
  },
  beforeDestroy: function () {
    //clean SignalR event
    this.$messageHub.$off("IdeaVoteChange", this.ideaVoteChange);
    this.$messageHub.$off("UpdatedNotice", this.updateNotice);
  },
  mounted() {
    this.loadItems(this.queryObject);
  },
  computed: {
    queryObject() {
      let val = this.$route.query ?? {};
      return {
        page: val.page ?? 1,
        pageSize: val.pageSize ?? 10,
        sortBy: val.sortBy ?? "UpdatedAt desc",
        keywords: val.keywords,
        isMine: val.isMine,
        status: Array.isArray(val.status)
          ? val.status
          : val.status
          ? [val.status]
          : [1, 2, 4],
        area: Array.isArray(val.area) ? val.area : val.area ? [val.area] : [],
        likeFrom: val.likeFrom,
        likeTo: val.likeTo,
      };
    },
    sipUser() {
      let sipUser = localStorage.getItem("sipUser");
      if (sipUser) {
        return JSON.parse(sipUser);
      } else {
        return null;
      }
    },
  },
  watch: {
    queryObject(val) {
      if (this.timeoutQuery) {
        clearTimeout(this.timeoutQuery);
      }
      this.timeoutQuery = setTimeout(() => {
        this.loadItems(val);
      }, 500);
    },
  },
  methods: {
    async loadItems(queryObj) {
      this.loading = true;

      try {
        let userId = this.sipUser ? this.sipUser.UserId : 0;
        let filter = [];
        filter.push(`SipIdeaOfChallenges/any() eq false`);

        if (queryObj.keywords) {
          let orFilters = [];
          orFilters.push(`contains(Title, '${queryObj.keywords}')`);
          orFilters.push(`contains(Description, '${queryObj.keywords}')`);
          orFilters.push(
            `contains(CreatedByNavigation/Name, '${queryObj.keywords}') and IsAnonymous eq false`
          );
          filter.push(orFilters.join(" or "));
        }

        if (queryObj.status && queryObj.status.length) {
          if (Array.isArray(queryObj.status)) {
            filter.push(`Status in (${queryObj.status.join(",")})`);
          } else {
            filter.push(`Status in (${[queryObj.status].join(",")})`);
          }
        }

        if (queryObj.area && queryObj.area.length) {
          if (Array.isArray(queryObj.area)) {
            filter.push(`AreaId in (${queryObj.area.join(",")})`);
          } else {
            filter.push(`AreaId in (${[queryObj.area].join(",")})`);
          }
        }

        let likeFrom = isNaN(queryObj.likeFrom)
          ? 0
          : parseInt(queryObj.likeFrom);
        if (likeFrom) {
          filter.push(`Votes ge ${likeFrom}`);
        } else if (likeFrom == 0) {
          filter.push(`(Votes ge ${likeFrom} or Votes eq null)`);
        }

        let likeTo = isNaN(queryObj.likeTo) ? 0 : parseInt(queryObj.likeTo);
        if (likeTo && likeTo < 99) {
          filter.push(`Votes le ${likeTo}`);
        }

        let params = {
          $top: queryObj.pageSize,
          $count: true,
          $orderby: queryObj.sortBy,
          $select:
            "Id,Title,Description,AttachedFiles,UpdatedAt,CreatedBy,Status,Votes,IsAnonymous",
          $skip: (queryObj.page - 1) * queryObj.pageSize,
          $expand: `Area($select=Name),CreatedByNavigation($select=Name,Email),SipIdeaVotes($top=1;$select=Id;$filter=UserId eq ${userId}),SipIdeaOfChallenges($top=0)`,
        };

        if (filter && filter.length) {
          params.$filter = filter.join(` and `);
        }
        if (
          queryObj.isMine &&
          (JSON.stringify(queryObj.isMine) == "true" ||
            queryObj.isMine == "true")
        ) {
          params.isMine = true;
        }

        let resp = await this.$http.get(`odata/SipIdea`, {
          params,
        });
        if (resp && resp.status == 200) {
          this.total = resp.data ? resp.data["@odata.count"] : 0;
          this.items =
            resp.data.value && resp.data.value.length
              ? resp.data.value.map((_) => {
                  _.seeMore = false;
                  _.working = false;
                  return _;
                })
              : [];
        } else {
          this.total = 0;
          this.items = [];
        }
      } catch (error) {
        alert(error);
      }

      setTimeout(() => {
        this.catchEventsForHashTag();
      }, 1000);

      this.loading = false;
    },

    reloadPage() {
      let queryObj = this.queryObject;
      if (queryObj && queryObj.page > 1) {
        let query = {};

        this.$router
          .push({
            name: "Idea",
            query,
            //hash: null,
          })
          .catch(() => {});
      } else {
        this.loadItems(queryObj);
      }
      this.hasNewUpdated = false;
    },

    async reloadInfo(ideaId) {
      if (ideaId) {
        let item = null;
        let userId = this.sipUser ? this.sipUser.UserId : 0;
        let params = {
          $top: 1,
          $filter: `Id eq ${ideaId}`,
          $select:
            "Id,Title,Description,AttachedFiles,UpdatedAt,CreatedBy,Status,Votes,IsAnonymous",
          $expand: `Area($select=Name),CreatedByNavigation($select=Name,Email),SipIdeaVotes($top=1;$select=Id;$filter=UserId eq ${userId}),SipIdeaOfChallenges($top=0)`,
        };
        let resp = await this.$http.get(`odata/SipIdea`, {
          params,
        });
        if (resp && resp.status == 200) {
          let record =
            resp.data.value && resp.data.value.length
              ? resp.data.value.map((_) => {
                  _.seeMore = false;
                  _.working = false;
                  return _;
                })[0]
              : null;
          if (record) {
            item = record;
          }
        }

        if (item) {
          let index = this.items.findIndex((_) => _.Id == ideaId);
          this.$set(this.items, index, item);
        }
      } else {
        this.loadItems(this.queryObject);
      }
    },

    async voteIdea(idea) {
      idea.working = true;
      try {
        let resp = await this.$http.post(`odata/SipIdeaVote`, {
          IdeaId: idea.Id,
        });
        if (resp && resp.status == 201) {
          //idea.Votes = idea.Votes ? idea.Votes + 1 : 1;
          idea.SipIdeaVotes = [{ Id: resp.data.Id }];
        }
      } catch (error) {
        console.log(error);
      }
      idea.working = false;
    },

    async unvoteIdea(idea) {
      idea.working = true;
      try {
        let voteId =
          idea.SipIdeaVotes && idea.SipIdeaVotes.length
            ? idea.SipIdeaVotes[0].Id
            : 0;
        if (voteId) {
          let resp = await this.$http.delete(`odata/SipIdeaVote/${voteId}`);
          if (resp && resp.status == 204) {
            //idea.Votes = idea.Votes && idea.Votes > 0 ? idea.Votes - 1 : 0;
            idea.SipIdeaVotes = [];
          }
        }
      } catch (error) {
        console.log(error);
      }
      idea.working = false;
    },

    async ideaVoteChange({ entityId, votes }) {
      let idea = this.items.find((_) => _.Id == entityId);
      if (idea) {
        idea.Votes = votes;

        // load vote state
        idea.working = true;
        try {
          let resp = await this.$http.get(`odata/SipIdeaVote`, {
            params: {
              $top: 1,
              $select: "Id",
              $filter: `IdeaId eq ${idea.Id}`,
            },
          });
          if (resp && resp.status == 200) {
            idea.SipIdeaVotes = resp.data.value;
          }
        } catch (error) {
          console.log(error);
        }
        idea.working = false;
      }
    },

    navigatePage(page) {
      if (this.queryObject.page != page) {
        let query = {
          page: page,
          pageSize: this.queryObject.pageSize,
          sortBy: this.queryObject.sortBy,
          keywords: this.queryObject.keywords,
          isMine: this.queryObject.isMine,
          status: this.queryObject.status,
          area: this.queryObject.area,
          likeFrom: this.queryObject.likeFrom,
          likeTo: this.queryObject.likeTo,
        };

        this.$router
          .push({
            name: "Idea",
            query,
            //hash: null,
          })
          .catch(() => {});
      }
    },

    getFirstImageName(attachedFiles) {
      let result = "";
      if (attachedFiles) {
        let files = JSON.parse(attachedFiles).filter(
          (_) =>
            _.endsWith(".jpg") ||
            _.endsWith(".jpeg") ||
            _.endsWith(".png") ||
            _.endsWith(".webp") ||
            _.endsWith(".gif") ||
            _.endsWith(".svg")
        );
        if (files && files.length) {
          result = files[0];
        }
      }
      return result;
    },

    showDateTime(createdAt) {
      return this.$moment().diff(this.$moment(createdAt), "weeks") < 1
        ? this.$moment(createdAt).fromNow()
        : this.$moment(createdAt).format("DD MMM YYYY, HH:mm");
    },

    replaceByDefault(e) {
      e.target.src = "/img/avatar.png";
    },

    catchEventsForHashTag() {
      let tags = this.$el.querySelectorAll(".description pre a");
      if (tags && tags.length) {
        tags.forEach((tag) => {
          tag.addEventListener("click", (e) => {
            let text = e.target.innerText;
            location.href = `/Idea?keywords=${encodeURIComponent(text)}`;
          });
        });
      }
    },

    updateNotice({ entityType }) {
      if (entityType == this.$const.ENTITY_NAMES.Idea) {
        this.hasNewUpdated = true;
      }
    },

    async deletePost(item) {
      if (confirm("Do you really want to delete this idea?")) {
        if (item.Status == this.$const.IDEA_STATUS.New) {
          // remove files
          let frmData = new FormData();
          frmData.append("Id", item.Id);
          frmData.append("IsReplaced", true);
          frmData.append("EntityName", "SipIdea");

          await this.$http.post("/SipFile", frmData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          let resp = await this.$http.delete(`/odata/SipIdea/${item.Id}`);
          if (resp && resp.status == 204) {
            // reload
            this.loadItems(this.queryObject);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-post {
  width: 100%;
  margin-bottom: 1rem;
}

.description {
  position: relative;

  pre {
    white-space: pre-line;
    font-family: inherit;
    font-size: 14px;
    width: 100%;
    margin-bottom: 0;
    max-height: 2.5rem;
    overflow: hidden;

    &.more-info {
      max-height: unset;
    }
  }

  .see-more {
    position: absolute;
    bottom: 0.3rem;
    right: 0;
    overflow: hidden;
    background: #fff;
    padding-left: 10px;
  }
}
</style>
